import * as H from 'preact/hooks';
/**
 * private Global store of dev commands
 */
const commands: Record<string, Function> = {};

/** List the current commands available to call */
export const list = () => Object.keys(commands);

/**
 * Add a command to the global store.
 *
 * This function is a Hook to ensure that the command is only added once per name, even in the face
 * of multiple calls
 *
 * See ticket TDC-875.
 *
 * Commands are used via the iFrame API, and so can be called from the console after calling
 * `fixtuur.list()`. See Dora ADR 002
 */
export const useAddCommand = (name: string, fn: Function, inputs: H.Inputs | undefined) => {
    H.useEffect(() => {
        commands[name] = fn;
    }, inputs);
};

/**
 * Call a command. Does nothing if no command by that name exists
 */
export const call = (name: string, args: any[]) => {
    if (commands[name] !== undefined) {
        commands[name](...args);
    }
};
